import { cn } from "@/lib/utils";

const TitleH1 = ({
  className,
  title,
}: {
  className?: string;
  title: React.ReactNode;
}) => {
  return (
    <h1
      className={cn(
        "text-primary [font-weight:var(--h1-weight,800)] tracking-wide leading-[1.5] text-[calc(34px*var(--h1-scale,var(--heading-scale,1)))] md:text-[calc(44px*var(--h1-scale,var(--heading-scale,1)))] xl:text-[calc(65px*var(--h1-scale,var(--heading-scale,1)))] xl:leading-[1.0769]",
        className,
      )}
    >
      {title}
    </h1>
  );
};

export default TitleH1;
